// GENERATED by tools/levels (pnpm levels:build). Do not edit by hand.
import type { FillPack } from "./schema.ts";

export const FILL_CONTENT_VERSION = "fill-1.0.0";

/** sha256 of each frozen chapter pack, checked by `pnpm levels:check`. */
export const FILL_PACK_SHA256: Readonly<Record<number, string>> = {
  1: "ce2cdd8478bf623a92260192524e85a59cf15d473450949370bb2c09f23a7ca3",
  2: "54e062f656df867b4e53fd569403b07fa5642139b233a00ee96de6b6f0df1c12",
  3: "91cb1f2a25dce47ff7741db58a063754c19f763a6f7eb0b38f8c5ba57ced386d",
  4: "000c97cdcb6b73ca0ad519279e70b5b8adf12ff23621c663ca6305c19e15bb26",
  5: "cfe7d4edc5cc03b119f7d72eb8736b00b2c0a9a712eec5b7a6e0387b73e64c01",
  6: "f6a623adcaa3c2239ec91babd305e38b35f146db38d7bac2ba63a2a41885d8c2",
  7: "c50cbc6e932aad0e81a27d734de4750945ecbff7ba612d34034bbcb8dab0e2f5",
  8: "86c16d731f30082324f14b64e3b59c6cdadf61c0a89fd06848af8b15601afecc",
  9: "98067f462f189de244ca0ac7ab673a7d32a050edf612cd53b6682dd9500d698c",
  10: "9095a4abdc24cfa079deef77466b331a3bb02db792c84b0bc36e97913c2f4855",
};

/** Lazy loaders: the client only downloads the chapter being played. */
export const FILL_PACK_LOADERS: Readonly<Record<number, () => Promise<FillPack>>> = {
  1: () => import("../../packs/fill/fill-1.0.0/chapter-01.json").then((m) => m.default as FillPack),
  2: () => import("../../packs/fill/fill-1.0.0/chapter-02.json").then((m) => m.default as FillPack),
  3: () => import("../../packs/fill/fill-1.0.0/chapter-03.json").then((m) => m.default as FillPack),
  4: () => import("../../packs/fill/fill-1.0.0/chapter-04.json").then((m) => m.default as FillPack),
  5: () => import("../../packs/fill/fill-1.0.0/chapter-05.json").then((m) => m.default as FillPack),
  6: () => import("../../packs/fill/fill-1.0.0/chapter-06.json").then((m) => m.default as FillPack),
  7: () => import("../../packs/fill/fill-1.0.0/chapter-07.json").then((m) => m.default as FillPack),
  8: () => import("../../packs/fill/fill-1.0.0/chapter-08.json").then((m) => m.default as FillPack),
  9: () => import("../../packs/fill/fill-1.0.0/chapter-09.json").then((m) => m.default as FillPack),
  10: () => import("../../packs/fill/fill-1.0.0/chapter-10.json").then((m) => m.default as FillPack),
};
